import {Store} from '../../../redux/Store'
import {AuthModel} from './_models'
import * as actions from '../../../redux/currentUser/CurrentUserAction'
import {signOut} from 'firebase/auth'
import {auth} from '../../../../firebaseConfig'

const setAuth = (auth: AuthModel, dispatch: any) => {
  try {
    dispatch(actions.setAuth(auth))
  } catch (error) {
    console.error('AUTH LOCAL STORAGE SAVE ERROR', error)
  }
}

const removeAuth = (dispatch: any) => {
  signOut(auth)
  dispatch(actions.removeAuth())
  dispatch(actions.removeCurrentUser())
}

export function setupAxios(axios: any) {
  axios.defaults.headers.Accept = 'application/json'

  axios.interceptors.request.use(
    (config: {url: string; headers: {Authorization: string; businessKey: string}}) => {
      const store = Store.getState()
      const auth = store.globalStates.auth

      if (auth && auth.api_token) {
        config.headers.Authorization = `Bearer ${auth.api_token}`
        if (auth.business_key !== undefined) config.headers.businessKey = `${auth.business_key}`
      }

      return config
    },
    (err: any) => Promise.reject(err)
  )

  axios.interceptors.response.use(
    (response: any) => {
      return response
    },
    async function (error: any) {
      console.log('error', error)
      if (error.response?.status === 401) {
        window.location.replace('/logout')
      }
      else if (error.response?.status === 403) {
        window.location.replace('/forbidden')
      }
      else if (error.response?.status === 406) {
        window.location.replace('/not_exist')
      }
      else if (error.response?.status === 423) {
        window.location.replace('/no_subscription')
      }
      else return Promise.reject(error)   
    }
  )
}

export {setAuth, removeAuth}
